/** Watermark rectangle, normalized to the photo: [left, top, width, height]. */
export type WatermarkRect = [number, number, number, number];

/**
 * Where the watermark goes: centered on the floor (its mean position), `size`
 * of the floor's width wide, kept between 25% and 60% of the photo width and
 * inside the photo. The floor is what a preview is shared for, so cropping
 * the mark out means cropping the floor. Falls back to the photo's center.
 * `aspect` is the watermark image's width / height.
 */
export function watermarkRect(mask: Uint8Array | null, width: number, height: number, aspect: number, size: number): WatermarkRect {
  let sx = 0;
  let sy = 0;
  let n = 0;
  let minX = width;
  let maxX = -1;
  if (mask) {
    for (let y = 0; y < height; y++) {
      const o = y * width;
      for (let x = 0; x < width; x++) {
        if (mask[o + x] <= 127) continue;
        sx += x;
        sy += y;
        n++;
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
      }
    }
  }
  const floorWidth = n ? maxX - minX + 1 : width;
  const w = Math.min(width * 0.6, Math.max(width * 0.25, floorWidth * size));
  const h = Math.min(height * 0.9, w / aspect);
  const wFit = h * aspect;
  const cx = n ? sx / n : width / 2;
  const cy = n ? sy / n : height / 2;
  const left = Math.min(width - wFit, Math.max(0, cx - wFit / 2));
  const top = Math.min(height - h, Math.max(0, cy - h / 2));
  return [left / width, top / height, wFit / width, h / height];
}
